module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/icon_1_fusion_x32-df923.png";